import { configureApiClient } from '@wwf/sdk';
import { getAccessToken, refreshSession } from '@core/api/auth-token';

export const apiService = configureApiClient({
    baseUrl: import.meta.env.VITE_API_BASE_URL,
    getAccessToken,
    refreshToken: refreshSession,
    apiVersion: '1.0',
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    locale: Intl.DateTimeFormat().resolvedOptions().locale,
    sourceVersion: import.meta.env.VITE_SOURCE_VERSION,
});
